import { Component } from '@theme/component';


/**
 * A custom element that manages a header menu.
 *
 * @typedef {Object} State
 * @property {boolean} open - Whether the menu is open.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} headerMenuDrawer - The header drawer.
 * @property {HTMLElement} headerBurger - The header burger.
 *
 * @extends {Component<Refs>}
 */
class HeaderMenuMobile extends Component {
  requiredRefs = ['headerMenuDrawer', 'headerBurger'];

  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * @type {State}
   */
  #state = {
    open: false,
  };

  open() {
    this.#state.open = true;
    this.refs.headerMenuDrawer.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.#state.open = false;
    this.refs.headerMenuDrawer.setAttribute('aria-hidden', 'true');
  }

  toggle() {
    this.#state.open = !this.#state.open;
    this.refs.headerMenuDrawer.setAttribute('aria-hidden', this.#state.open ? 'false' : 'true');
  }
}

if (!customElements.get('header-menu-mobile')) {
  customElements.define('header-menu-mobile', HeaderMenuMobile);
}